import { ItiBaseDto } from '@/iti-core-vue';

export class Post extends ItiBaseDto {
    public id!: number;
    public title!: string;
    public content!: string;
    public ambitId!: number;
    public userId!: number;
    public numberOfReplys!: number;
    public lastModificationDate!: Date;
    public creationDate!: Date;
    public userName!: string;
    public userNameOfLastReply!: string;
    public creationDateOfLastReply!: Date;
    public canEdit!: boolean;
    public canDelete!: boolean;
}
